export default {
  event: state => state.event,
  eventFilter: state => state.events.filters.type,
  eventSearch: state => state.events.filters.search,
  eventTypes: state => state.eventTypes,
  events: state => state.events,
  eventsNew: state => state.eventsNew,
  eventsItems: state => state.events.items,
  eventsLimit: state => state.events.limit,
  eventsLoading: state => state.events.loading,
  eventsPage: state => state.events.page,
  eventsTotal: state => state.events.total,

  logs: state => state.logs,
  logsItems: state => state.logs.items,
  logsLoading: state => state.logs.loading,
  logsLoop: state => state.logs.loop,
  self: state => state.self,

  // game-related properties
  teams: state => state.teams,
  kits: state => state.kits,

  // on-canvas selection properties
  selectedObject: state => state.selectedObject,
  detects: state => state.detects,
  detectLabels: state => state.filters.detectLabels,
  detectTypes: state => state.filters.detectTypes,
  detectCurrent: state => state.detectCurrent,
  detectsFiltered: state => state.detectsFiltered,
  prevNewDetect: state => state.prevNewDetect,

  field: state => state.field,
  fieldId: state => state.field.id,
  fieldLabelVisibility: state => state.field.showLabel,
  fieldPoints: state => state.field.points,
  fieldPointsCanonical: state => state.field.pointsCanonical,

  lineupsVisibility: state => state.filters.lineups,
  showInterpolatedDetects: state => state.filters.interpolated,
  showOnlyOneDetect: state => state.filters.showSelectedDetect,

  currentFrame: state => state.currentFrame,

  canvasImage: state => type => state[type].img,
  canvasIsShow: state => type => state[type].visible,
  canvasSize: state => type => state[type].size,
  action: state => state.action,

  loading: state => type => state[type].loading,
  isLoading: state => type => !!state[type].loading.length,

  statistic: state => state.statistic,
  statisticFrame: state => state.statistic.frame,
  statisticGame: state => state.statistic.game,
  statisticPlayers: state => state.statistic.players,
  teamShapesVisibility: state => state.statistic.showTeamShapes,

  view: state => state.view,
};
